import axios, { type AxiosInstance } from "axios";
import { getApiBaseUrl } from "@/utils/apiUtils";

/**
 * Login client — usado apenas no endpoint que troca usuário/senha pelo token
 * de API (get_user_api_keys). Não precisa de cookie: o token vem no corpo da
 * resposta. Mantido separado do httpClient autenticado para não depender do
 * auth store (que ainda não existe no momento do login).
 */
export const loginClient: AxiosInstance = axios.create({
  baseURL: getApiBaseUrl(),
  timeout: 60000,
  withCredentials: false,
  headers: {
    "Content-Type": "application/json",
    Accept: "application/json",
  },
});

/**
 * Public client — withCredentials: false. Used for endpoints that must NOT
 * receive any credential (forgot-password, update-password by key, etc.).
 */
export const publicClient: AxiosInstance = axios.create({
  baseURL: getApiBaseUrl(),
  timeout: 60000,
  withCredentials: false,
  headers: {
    "Content-Type": "application/json",
    Accept: "application/json",
  },
});
